module.exports = __webpack_public_path__ + "static/media/country_ca.e12122da.webp";